import React from "react";
import styled from "styled-components";
import * as colors from "../../../../assets/_base/colors";

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100% !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  border: 0 !important;
  align-items: baseline;
  align-self: baseline;

  @media (max-width: 800px) {}
`;
const Hr = styled.hr`
    height: 1px;
    border-radius: 8px;
    background-color: ${colors.darkBlue};
    margin: 0px;
`;

export default (props) => {
  return (
    <div className="w-100">
      <Nav>{props.children}</Nav>
      <Hr />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/Nav/index.jsx